// Sri Lankan time utilities
// Sri Lanka Standard Time (SLST) is UTC+5:30
// Using proper timezone conversion with Asia/Colombo

/**
 * Get current Sri Lankan date in YYYY-MM-DD format
 */
export const getSriLankaToday = () => {
  const now = new Date();
  // Use proper timezone conversion
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Colombo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  return formatter.format(now); // Returns YYYY-MM-DD format
};

/**
 * Get current Sri Lankan time in HH:MM:SS format
 */
export const getSriLankaNow = () => {
  const now = new Date();
  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Colombo',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
  return formatter.format(now); // Returns HH:MM:SS format
};

/**
 * Get current Sri Lankan date and time
 */
export const getSriLankaDateTime = () => {
  const now = new Date();
  
  const dateFormatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Colombo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  
  const timeFormatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Colombo',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
  
  return {
    date: dateFormatter.format(now),
    time: timeFormatter.format(now),
  };
};

/**
 * Convert a Date object or date string to Sri Lankan date string (YYYY-MM-DD)
 */
export const toSriLankaDate = (date) => {
  // Handle both string and Date object inputs
  const dateObj = typeof date === "string" ? new Date(date) : date;
  
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Colombo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  
  return formatter.format(dateObj);
};

/**
 * Get Sri Lankan date for a number of days ago
 */
export const getSriLankaDaysAgo = (daysAgo) => {
  const now = new Date();
  const offsetInMilliseconds = 5.5 * 60 * 60 * 1000; // UTC+5:30
  const sriLankaTime = new Date(now.getTime() + offsetInMilliseconds);
  sriLankaTime.setDate(sriLankaTime.getDate() - daysAgo);
  return sriLankaTime.toISOString().split("T")[0];
};

/**
 * Format ISO string to Sri Lankan date and time display
 */
export const formatSriLankaDateTime = (isoString) => {
  const date = new Date(isoString);
  return date.toLocaleString("en-LK", {
    timeZone: "Asia/Colombo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};

/**
 * Format date string to Sri Lankan date display
 */
export const formatSriLankaDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-LK", {
    timeZone: "Asia/Colombo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};
